import React, { Component } from 'react'

class BooksBorrowed extends Component {
    state = {  }
    render() { 
        return ( <section className="mt-5">
            Books Borrowed
        </section> );
    }
}
 
export default BooksBorrowed;